'use client';

var SELECT_EMPTY_OPTION_ID = -1;
var EAlertType;
(function (EAlertType) {
    EAlertType["info"] = "info";
    EAlertType["success"] = "success";
    EAlertType["danger"] = "danger";
    EAlertType["warning"] = "warning";
})(EAlertType || (EAlertType = {}));
var ELanguage;
(function (ELanguage) {
    ELanguage["EN"] = "en";
    ELanguage["VI"] = "vi";
})(ELanguage || (ELanguage = {}));
var EAppMode;
(function (EAppMode) {
    EAppMode["staging"] = "staging";
    EAppMode["release"] = "release";
    EAppMode["production"] = "production";
})(EAppMode || (EAppMode = {}));
var pathPage = [
    {
        page: 'search-result',
        path: ['/job-search/all-jobs', '/tim-viec-lam/tim-tat-ca-viec-lam', '-kv', '-kw', '-en', '-vn']
    },
    {
        page: 'job-detail',
        path: ['-jv', '-jd']
    },
    {
        page: 'wowcv',
        path: ['wowcv.']
    },
    {
        page: 'company-info',
        path: ['/cong-ty', '/companies']
    },
    {
        page: 'interview',
        path: ['/cau-hoi-phong-van/', '/interview/']
    },
    {
        page: 'salary',
        path: ['/muc-luong/', '/salary/']
    },
    {
        page: 'dashboard',
        path: ['/quan-ly-nghe-nghiep/quan-ly-ho-so', '/my-career-center/dashboard']
    },
    {
        page: 'my-profile',
        path: ['/ho-so', '/my-profile']
    },
    {
        page: 'profile-settings',
        path: ['/quan-ly-nghe-nghiep/thiet-lap-ho-so', '/my-career-center/profile-settings']
    },
    {
        page: 'profile-view',
        path: ['/quan-ly-nghe-nghiep/nha-tuyen-dung-nao-xem-ho-so-cua-ban', '/my-career-center/who-view-my-resume']
    },
    {
        page: 'my-jobs',
        path: ['/quan-ly-nghe-nghiep/viec-lam-cua-toi', '/my-career-center/my-jobs']
    },
    {
        page: 'job-alert',
        path: ['/quan-ly-nghe-nghiep/thong-bao-viec-lam', '/my-career-center/my-job-alert']
    },
    {
        page: 'account-settings',
        path: ['/quan-ly-tai-khoan', '/account-settings']
    }
];
var colors = {
    textColor: '#333333',
    textPlaceholder: '#999999',
    textGrayColor: '#848484',
    primaryColor: '#005AFF',
    secondaryColor: '#979797',
    buttonColor: '#FF7D55',
    infoColor: '#48BBFF',
    successColor: '#50B704',
    dangerColor: '#FF4A53',
    highlightColor: '#f7be06',
    darkBlueColor: '#001744',
    bgNormal: '#fbfbfc',
    bgHover: '#f7faff',
    bgError: '#FFF9F9',
    bgDisable: '#F6F8FB',
    bgHeader: '#e5eeff',
    borderNormal: '#D9D9D9',
    borderHover: '#80ADFF',
    borderFocus: '#0066FF',
    borderError: '#FF4A53',
    borderErrorFocus: '#fd2020',
    borderDisable: '#E8EDF6',
    borderCard: '#e0e0e9',
    cardShadow: '#efefef',
    tagSelect: '#E6EFFF',
    tagSelectBorder: '#B3CEFF',
    tagHover: '#CCDEFF',
    jobCardBorder: '#f1f1f1',
    jobCardHover: '#f8f9fa',
    saveIconHover: '#eff5ff'
};
/**
    staging: 252025
    release: 330189 (Manual), 330355 (Auto)
    production: 18364, 319884
 */
var NAVIGOS_COMPANY_ID = {
    staging: [252025],
    release: [330189, 330355],
    production: [18364, 319884]
};
var SEARCH_PARAMS;
(function (SEARCH_PARAMS) {
    SEARCH_PARAMS["QUERY"] = "q";
    SEARCH_PARAMS["LOCATION"] = "l";
    SEARCH_PARAMS["CATEGORY"] = "f";
    SEARCH_PARAMS["GROUP_JOB_FUNCTION"] = "g";
    SEARCH_PARAMS["JOB_FUNCTION"] = "j";
    SEARCH_PARAMS["INDUSTRY"] = "i";
    SEARCH_PARAMS["WORKING_TYPE"] = "w";
    SEARCH_PARAMS["JOB_LEVEL"] = "level";
    SEARCH_PARAMS["SALARY"] = "s";
    SEARCH_PARAMS["URGENT"] = "urgent";
    SEARCH_PARAMS["LANGUAGE"] = "lang";
    SEARCH_PARAMS["PAGE"] = "page";
    SEARCH_PARAMS["SORTING"] = "sorting";
    SEARCH_PARAMS["DISTRICT"] = "d";
})(SEARCH_PARAMS || (SEARCH_PARAMS = {}));
var ROUTE_SEARCH;
(function (ROUTE_SEARCH) {
    ROUTE_SEARCH["RESULT"] = "/job-search/all-jobs";
    ROUTE_SEARCH["RESULT_VI"] = "/tim-viec-lam/tim-tat-ca-viec-lam";
    ROUTE_SEARCH["JOBS"] = "/jobs";
    ROUTE_SEARCH["JOBS_VI"] = "/viec-lam";
})(ROUTE_SEARCH || (ROUTE_SEARCH = {}));
// Private IP of Fortiweb
var FORTIWEB_IP = ['10.122.10.10', '10.122.10.11', '10.122.4.11', '10.122.4.12', '10.122.4.13'];
// Locations
var VIETNAM_COUNTRY_ID = 1;
var INTERNATIONAL_CITY_ID = 70;

export { EAlertType, EAppMode, ELanguage, FORTIWEB_IP, INTERNATIONAL_CITY_ID, NAVIGOS_COMPANY_ID, ROUTE_SEARCH, SEARCH_PARAMS, SELECT_EMPTY_OPTION_ID, VIETNAM_COUNTRY_ID, colors, pathPage };
//# sourceMappingURL=constants.js.map
